class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.timer = undefined;
    this.slides = Array.from(this.querySelectorAll('.hero-slide'));
    if (this.slides.length < 2) return;

    this.index = this.slides.findIndex((slide) => slide.classList.contains('active'));
    if (this.index < 0) {
      this.index = 0;
      this.slides[0].classList.add('active');
    }

    // 次に出るスライドを先読みしておく。3 枚目以降は Liquid が src を書かず
    // data-src だけを持つため、切り替わる手前で読み込みを始める。
    this.preload(this.index + 1);

    // 動きを減らす設定のときは自動再生しない（1 枚目で止める）。
    // クロスフェード自体の無効化は theme.css の prefers-reduced-motion 側で行う。
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // 既定の 3000ms は sections/hero.liquid の interval 設定（default: 3）と対応する。
    // 片方を変えるときはもう片方も確認すること。
    const interval = parseInt(this.dataset.interval, 10);
    this.timer = setInterval(() => this.showNext(), interval > 0 ? interval : 3000);
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  preload(position) {
    const slide = this.slides[position % this.slides.length];
    if (!slide || slide.hasAttribute('src')) return;

    const src = slide.dataset.src;
    if (src) slide.setAttribute('src', src);
  }

  showNext() {
    this.slides[this.index].classList.remove('active');
    this.index = (this.index + 1) % this.slides.length;
    this.slides[this.index].classList.add('active');
    this.preload(this.index + 1);
  }
}

customElements.define('hero-slideshow', HeroSlideshow);
